import React from 'react';
import { useI18n } from '../i18n/I18nProvider.jsx';

export default function Why() {
  const { t } = useI18n();
  const cards = t('why.cards');
  return (
    <section className="why-section">
      <div className="fone-top"></div>
      <div className="why-inner">
        <span className="section-tag">{t('why.tag')}</span>
        <h2 className="section-title" dangerouslySetInnerHTML={{ __html: t('why.title') }} />
        <p className="section-sub">{t('why.sub')}</p>
        <div className="why-grid">
          {Array.isArray(cards) && cards.map((c, i) => (
            <div className="why-card" key={i}>
              <span className="emoji">{c.emoji}</span>
              <h3>{c.title}</h3>
              <p>{c.text}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="fone-bottom"></div>
    </section>
  );
}